import { styled } from "styled-components";

export const StyledLandingTitle = styled.h2`
  font-size: 2rem;
  margin: 0 0 0.5rem 0;
  color: ${({ theme }) => theme.colors.textBright};
`;
